import React from 'react';
import styled from 'styled-components';
import { flexCenter } from '../Flex';

const SIZES = {
  xsmall: 14,
  small: 20,
  medium: 50
};

const THICKNESS = {
  xsmall: 1,
  small: 2,
  medium: 3
};

const Wrapper = styled.div`
  ${flexCenter};
  .lds-ring {
    display: inline-block;
    position: relative;
    width: ${({ size }) => SIZES[size] || size}px;
    height: ${({ size }) => SIZES[size] || size}px;
  }
  .lds-ring div {
    display: block;
    position: absolute;
    width: ${({ size }) => SIZES[size] || size}px;
    height: ${({ size }) => SIZES[size] || size}px;
    border: ${({ theme, thickness }) => `${THICKNESS[thickness] || thickness}px solid ${theme.colors.primary}`};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({ theme }) => theme.colors.primary} transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Loader = ({ className, size = 'medium', thickness = 'medium' }) => (
  <Wrapper className={className} size={size} thickness={thickness}>
    <div className="lds-ring">
      <div />
      <div />
      <div />
      <div />
    </div>
  </Wrapper>
);

export default Loader;
